module.exports = __webpack_public_path__ + "static/img/人脸识别.85547cda.png";